/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as RRouteImport } from './../routes/r'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as InviteRouteImport } from './../routes/invite'
import { Route as ForgotPasswordRouteImport } from './../routes/forgot-password'
import { Route as FirstTimeLoginOtpVerificationRouteImport } from './../routes/first-time-login-otp-verification'
import { Route as AuthenticatedRouteImport } from './../routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './../routes/_authenticated.index'
import { Route as AuthenticatedRecentActivityRouteImport } from './../routes/_authenticated.recent-activity'
import { Route as AuthenticatedPendingSettlementsRouteImport } from './../routes/_authenticated.pending-settlements'
import { Route as AuthenticatedNeedsAttentionRouteImport } from './../routes/_authenticated.needs-attention'
import { Route as AuthenticatedHelpSupportRouteImport } from './../routes/_authenticated.help-support'
import { Route as AuthenticatedDashboardRouteImport } from './../routes/_authenticated.dashboard'
import { Route as AuthenticatedAuditTrailRouteImport } from './../routes/_authenticated.audit-trail'
import { Route as AuthenticatedGroupsIndexRouteImport } from './../routes/_authenticated.groups.index'
import { Route as AuthAppleCallbackRouteImport } from './../routes/auth.apple.callback'
import { Route as AuthenticatedGroupsGroupIdRouteImport } from './../routes/_authenticated.groups.$groupId'

const RRoute = RRouteImport.update({
  id: '/r',
  path: '/r',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FirstTimeLoginOtpVerificationRoute =
  FirstTimeLoginOtpVerificationRouteImport.update({
    id: '/first-time-login-otp-verification',
    path: '/first-time-login-otp-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRecentActivityRoute =
  AuthenticatedRecentActivityRouteImport.update({
    id: '/recent-activity',
    path: '/recent-activity',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPendingSettlementsRoute =
  AuthenticatedPendingSettlementsRouteImport.update({
    id: '/pending-settlements',
    path: '/pending-settlements',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNeedsAttentionRoute =
  AuthenticatedNeedsAttentionRouteImport.update({
    id: '/needs-attention',
    path: '/needs-attention',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelpSupportRoute =
  AuthenticatedHelpSupportRouteImport.update({
    id: '/help-support',
    path: '/help-support',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditTrailRoute = AuthenticatedAuditTrailRouteImport.update({
  id: '/audit-trail',
  path: '/audit-trail',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsIndexRoute =
  AuthenticatedGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthAppleCallbackRoute = AuthAppleCallbackRouteImport.update({
  id: '/auth/apple/callback',
  path: '/auth/apple/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedGroupsGroupIdRoute =
  AuthenticatedGroupsGroupIdRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/first-time-login-otp-verification': typeof FirstTimeLoginOtpVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/r': typeof RRoute
  '/audit-trail': typeof AuthenticatedAuditTrailRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/help-support': typeof AuthenticatedHelpSupportRoute
  '/needs-attention': typeof AuthenticatedNeedsAttentionRoute
  '/pending-settlements': typeof AuthenticatedPendingSettlementsRoute
  '/recent-activity': typeof AuthenticatedRecentActivityRoute
  '/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
  '/groups/': typeof AuthenticatedGroupsIndexRoute
}
export interface FileRoutesByTo {
  '/first-time-login-otp-verification': typeof FirstTimeLoginOtpVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/r': typeof RRoute
  '/audit-trail': typeof AuthenticatedAuditTrailRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/help-support': typeof AuthenticatedHelpSupportRoute
  '/needs-attention': typeof AuthenticatedNeedsAttentionRoute
  '/pending-settlements': typeof AuthenticatedPendingSettlementsRoute
  '/recent-activity': typeof AuthenticatedRecentActivityRoute
  '/': typeof AuthenticatedIndexRoute
  '/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
  '/groups': typeof AuthenticatedGroupsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/first-time-login-otp-verification': typeof FirstTimeLoginOtpVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/r': typeof RRoute
  '/_authenticated/audit-trail': typeof AuthenticatedAuditTrailRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/help-support': typeof AuthenticatedHelpSupportRoute
  '/_authenticated/needs-attention': typeof AuthenticatedNeedsAttentionRoute
  '/_authenticated/pending-settlements': typeof AuthenticatedPendingSettlementsRoute
  '/_authenticated/recent-activity': typeof AuthenticatedRecentActivityRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/auth/apple/callback': typeof AuthAppleCallbackRoute
  '/_authenticated/groups/': typeof AuthenticatedGroupsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/first-time-login-otp-verification'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/r'
    | '/audit-trail'
    | '/dashboard'
    | '/help-support'
    | '/needs-attention'
    | '/pending-settlements'
    | '/recent-activity'
    | '/groups/$groupId'
    | '/auth/apple/callback'
    | '/groups/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/first-time-login-otp-verification'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/r'
    | '/audit-trail'
    | '/dashboard'
    | '/help-support'
    | '/needs-attention'
    | '/pending-settlements'
    | '/recent-activity'
    | '/'
    | '/groups/$groupId'
    | '/auth/apple/callback'
    | '/groups'
  id:
    | '__root__'
    | '/_authenticated'
    | '/first-time-login-otp-verification'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/r'
    | '/_authenticated/audit-trail'
    | '/_authenticated/dashboard'
    | '/_authenticated/help-support'
    | '/_authenticated/needs-attention'
    | '/_authenticated/pending-settlements'
    | '/_authenticated/recent-activity'
    | '/_authenticated/'
    | '/_authenticated/groups/$groupId'
    | '/auth/apple/callback'
    | '/_authenticated/groups/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  FirstTimeLoginOtpVerificationRoute: typeof FirstTimeLoginOtpVerificationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  RRoute: typeof RRoute
  AuthAppleCallbackRoute: typeof AuthAppleCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/r': {
      id: '/r'
      path: '/r'
      fullPath: '/r'
      preLoaderRoute: typeof RRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/first-time-login-otp-verification': {
      id: '/first-time-login-otp-verification'
      path: '/first-time-login-otp-verification'
      fullPath: '/first-time-login-otp-verification'
      preLoaderRoute: typeof FirstTimeLoginOtpVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recent-activity': {
      id: '/_authenticated/recent-activity'
      path: '/recent-activity'
      fullPath: '/recent-activity'
      preLoaderRoute: typeof AuthenticatedRecentActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pending-settlements': {
      id: '/_authenticated/pending-settlements'
      path: '/pending-settlements'
      fullPath: '/pending-settlements'
      preLoaderRoute: typeof AuthenticatedPendingSettlementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/needs-attention': {
      id: '/_authenticated/needs-attention'
      path: '/needs-attention'
      fullPath: '/needs-attention'
      preLoaderRoute: typeof AuthenticatedNeedsAttentionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help-support': {
      id: '/_authenticated/help-support'
      path: '/help-support'
      fullPath: '/help-support'
      preLoaderRoute: typeof AuthenticatedHelpSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit-trail': {
      id: '/_authenticated/audit-trail'
      path: '/audit-trail'
      fullPath: '/audit-trail'
      preLoaderRoute: typeof AuthenticatedAuditTrailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/': {
      id: '/_authenticated/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthenticatedGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/apple/callback': {
      id: '/auth/apple/callback'
      path: '/auth/apple/callback'
      fullPath: '/auth/apple/callback'
      preLoaderRoute: typeof AuthAppleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/groups/$groupId': {
      id: '/_authenticated/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAuditTrailRoute: typeof AuthenticatedAuditTrailRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedHelpSupportRoute: typeof AuthenticatedHelpSupportRoute
  AuthenticatedNeedsAttentionRoute: typeof AuthenticatedNeedsAttentionRoute
  AuthenticatedPendingSettlementsRoute: typeof AuthenticatedPendingSettlementsRoute
  AuthenticatedRecentActivityRoute: typeof AuthenticatedRecentActivityRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedGroupsGroupIdRoute: typeof AuthenticatedGroupsGroupIdRoute
  AuthenticatedGroupsIndexRoute: typeof AuthenticatedGroupsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditTrailRoute: AuthenticatedAuditTrailRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedHelpSupportRoute: AuthenticatedHelpSupportRoute,
  AuthenticatedNeedsAttentionRoute: AuthenticatedNeedsAttentionRoute,
  AuthenticatedPendingSettlementsRoute: AuthenticatedPendingSettlementsRoute,
  AuthenticatedRecentActivityRoute: AuthenticatedRecentActivityRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedGroupsGroupIdRoute: AuthenticatedGroupsGroupIdRoute,
  AuthenticatedGroupsIndexRoute: AuthenticatedGroupsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  FirstTimeLoginOtpVerificationRoute: FirstTimeLoginOtpVerificationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  RRoute: RRoute,
  AuthAppleCallbackRoute: AuthAppleCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
